import api from 'services/api'
import { stringifyPageQuery } from 'services/utils'

export const createCustomField = values => api.post('/custom-fields', values)

export const fetchCustomField = id => api.get(`/custom-fields/${id}`)

export const fetchCustomFieldsPage = (params) => api.get(`/custom-fields?${stringifyPageQuery(params)}`)

export const updateCustomField = (id, values) => api.put(`/custom-fields/${id}`, values)

export const getCustomFieldsByModule = (module) => api.get(`/custom-module-fields/${module}`)

export const getCustomFieldValue = (fieldId, entityId) => api.get(`/custom-fields/${fieldId}/values-for-entities/${entityId}`)

export const setCustomFieldValue = (fieldId, entityId, value) => api.put(`/custom-fields/${fieldId}/values-for-entities/${entityId}`, value)